import { AcroFormFiller } from '@/features/acroform-filler'
import { ToolPageShell } from '@/shared/seo'

export function ZapolnitPdfFormuPage() {
  return (
    <ToolPageShell utilityKey="fill-pdf-form">
      <AcroFormFiller />
    </ToolPageShell>
  )
}
